import { createSelector } from 'reselect'
import { locationsSelector } from '../grs/selectors'

const extendingSelector = state => state.extending || {}
const reservationIdSelector = createSelector(extendingSelector, extending => extending.reservationId)

export const extendingDateTimeSelector = createSelector(extendingSelector, ({ start, end }) => ({
    start,
    end,
}))
const entitiesSelector = state => state.entities || {}
const reservationsSelector = createSelector(entitiesSelector, entities => entities.reservations || {})
export const reservationSelector = createSelector(
    reservationsSelector,
    reservationIdSelector,
    (reservations, reservationId) => reservations[reservationId] || {}
)

const reservationCreditCardIdSelector = createSelector(reservationSelector, reservation => reservation.cardId)

const creditCardsSelector = createSelector(entitiesSelector, entities => entities.creditCards || {})
export const reservationCreditCardSelector = createSelector(
    reservationCreditCardIdSelector,
    creditCardsSelector,
    (creditCardId, creditCardsSelector) => creditCardsSelector[creditCardId] || {}
)
export const extendingErrorSelector = createSelector(extendingSelector, ({ extendingError }) => extendingError)
export const reservationLocationIdSelector = createSelector(reservationSelector, reservation => reservation.locationId)
export const locationDetailsSelector = createSelector(
    locationsSelector,
    reservationLocationIdSelector,
    (locations, reservationId) => locations[reservationId]
)
